import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import DetailTrainingServices from "./detailTraining.services";
import trainingAssistanceServices from "../Training_assistance/trainingAssistance.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getDetailTraining = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_DETAIL_TRAINING,
      payload: true,
    });
    const resp = await DetailTrainingServices.getDetailTraining(filters);
    dispatch({
      type: actions.GET_DETAIL_TRAINING,
      payload: resp.data,
    });
    dispatch({
      type: actions.DETAIL_TRAINING_FAIL,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.DETAIL_TRAINING_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_DETAIL_TRAINING,
      payload: false,
    });
  }
};

export const deleteDetailTraining =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_DETAIL_TRAINING,
        payload: true,
      });
      await DetailTrainingServices.deleteDetailTraining(id);
      const { data, count } = getState().detailTraining.detailTraining;
      let _data = data.slice();
      _data.splice(index, 1);
      dispatch({
        type: actions.GET_DETAIL_TRAINING,
        payload: {
          data: _data,
          count: count - 1,
        },
      });
      dispatch({
        type: actions.DETAIL_TRAINING_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.DETAIL_TRAINING_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_DETAIL_TRAINING,
        payload: false,
      });
    }
  };

export const editDetailTraining =
  (
    req,
    id,
    id_empleado,
    index,
    setShowModal,
    id_documento,
    dataArchive,
    subidaDoc
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_DETAIL_TRAINING,
        payload: true,
      });
    //   debugger;
      let reqDoc, resp;
      const { data, count } = getState().detailTraining.detailTraining;
      let _data = data.slice();
      if (subidaDoc) {
        if (id_documento) {
          reqDoc = await DetailTrainingServices.editArchive(
            id_documento,
            dataArchive
          );
        } else {
          reqDoc = await DetailTrainingServices.saveArchive(dataArchive);
        }
        // await trainingAssistanceServices.editTrainingAssistance(req.id, {... req, archivo: reqDoc.data.resultado.id});
        // _data[index].archivo_id = reqDoc.data.resultado.id;
        // _data[index].list_archivo[0] = reqDoc.data.resultado;
        resp = await DetailTrainingServices.editDetailTraining(req.id, {
          ...req,
          archivo: reqDoc.data.resultado.id,
          filter: id_empleado,
          evento_id: id,
        });
      } else {
        // resp = await DetailTrainingServices.editDetailTraining(req.id, req);
        resp = await DetailTrainingServices.editDetailTraining(req.id, {
          ...req,
          filter: id_empleado,
          evento_id: id,
        });
      }
      // resp = await DetailTrainingServices.getDetailTrainingById(id);
      _data = resp.data.data;
      // _data[index] = resp.data;
      // _data[index].calificacion = resp.data.nota_evaluacion;
      // _data[index].detalle_evento[0] = resp.data;
      dispatch({
        type: actions.GET_DETAIL_TRAINING,
        payload: {
          data: _data,
          count: count,
        },
      });
      dispatch({
        type: actions.FORM_DETAIL_TRAINING_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.DETAIL_TRAINING_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_DETAIL_TRAINING,
        payload: false,
      });
    }
  };

export const saveDetailTraining =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_DETAIL_TRAINING,
        payload: true,
      });
      const resp = await DetailTrainingServices.saveDetailTraining(req);
      const { data, count } = getState().detailTraining.detailTraining;
      dispatch({
        type: actions.GET_DETAIL_TRAINING,
        payload: {
          count: count + 1,
          data: [...data, resp.data],
        },
      });
      dispatch({
        type: actions.FORM_DETAIL_TRAINING_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_DETAIL_TRAINING_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_DETAIL_TRAINING,
        payload: false,
      });
    }
  };
